/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { createRequestToDetachInvestor } from '../../../redux/actions/investor/detachInvestor';
import { PAMMState } from '../../../redux/reducers/rootReducer';
import { Investor } from '../../../types/investorTypes';
import { Master } from '../../../types/masterTypes';
import { setDisconnectFromMasterConfirmationStatus } from '../../../redux/actions/setMobileMenusStatus';
import { spaceSeparatedThousands } from '../../../utils/number';
import { VisibilityExtendedToggle } from '../../../types/toggles';
import style from './ConfirmDisconnectFromMasterMenuMobile.module.css';
import { useUser } from '../../../utils/useUser';
import { applyStyles } from '../../../utils/applyStyles';
import EquityDisplay from '../../shared/EquityDisplay';
import { getEquityOverInvestmentsCredit } from '../../../utils/value';

const ConfirmDisconnectFromMasterMenu: React.FC<any> = ({ onSwipe, onCancel }): JSX.Element => {
  const dispatch = useDispatch();
  const history: History = useHistory();

  const user = useUser();
  const show = useSelector((state: PAMMState) => state.mobileMenusStatusReducer.showDisconnectFromMasterConfirmation);

  const api: string = useSelector((state: PAMMState) => state.configReducer.api);
  const investor: Investor = useSelector((state: PAMMState) => state.investorReducer.investor);
  const master: Master = useSelector((state: PAMMState) => state.masterReducer.master);

  const handleAttach = (): void => {
    dispatch(createRequestToDetachInvestor(api, investor.Id.toString(), master.Id.toString(), history));
    dispatch(setDisconnectFromMasterConfirmationStatus(false));
  };

  return (
    <div
      id="confirm-disconnect-from-master-menu"
      className={applyStyles([style['menu'], show ? style['show'] : style['hide']])}
      onPointerMove={(event) => onSwipe(event)}
      onPointerCancel={() => onCancel('confirmDisconnectFromMasterMenu')}
    >
      <h6 className={applyStyles([style['title'], 'text-h4-semibold'])}>
        <FormattedMessage id="masterDetails.mobile.disconnectFromThisMaster" />?
      </h6>
      {(user?.AccountInfo?.AccountOptions?.InvestorOpenOrdersTab === VisibilityExtendedToggle.Show ||
        user?.AccountInfo?.AccountOptions?.InvestorOpenOrdersTab === VisibilityExtendedToggle.OnlyProfit) && (
        <div className={applyStyles([style['equity'], 'text-h4'])}>
          <span className={style['equity-title']}>
            <FormattedMessage id="investorDetails.balanceIndicators.equity" />:
          </span>
          <span>
            {investor?.Currency} {spaceSeparatedThousands(investor?.Equity)}
          </span>
          <EquityDisplay equityValue={Number(getEquityOverInvestmentsCredit(investor))} />
        </div>
      )}

      <button onClick={handleAttach} className={applyStyles([style['button'], 'text-semibold'])} type="button">
        <FormattedMessage id="button.disconnect" />
      </button>
    </div>
  );
};

export default ConfirmDisconnectFromMasterMenu;
